import { Record, Union } from "../../../fable_modules/fable-library-js.4.19.0/Types.js";
import { record_type, string_type, union_type } from "../../../fable_modules/fable-library-js.4.19.0/Reflection.js";

export class Page extends Union {
    constructor() {
        super();
        this.tag = 0;
        this.fields = [];
    }
    cases() {
        return ["Beratungstermin"];
    }
}

export function Page_$reflection() {
    return union_type("Beratungstermin.Types.Page", [], Page, () => [[]]);
}

export class Model extends Record {
    constructor(BeratungsterminUrl) {
        super();
        this.BeratungsterminUrl = BeratungsterminUrl;
    }
}

export function Model_$reflection() {
    return record_type("Beratungstermin.Types.Model", [], Model, () => [["BeratungsterminUrl", string_type]]);
}

export class Msg extends Union {
    constructor() {
        super();
        this.tag = 0;
        this.fields = [];
    }
    cases() {
        return ["NoOp"];
    }
}

export function Msg_$reflection() {
    return union_type("Beratungstermin.Types.Msg", [], Msg, () => [[]]);
}

//# sourceMappingURL=Types.fs.js.map
